import React, {useCallback, useEffect, useState} from 'react';
import './sd.scss';
import {ArrowBack} from '@mui/icons-material';
import Fab from '@mui/material/Fab';
import {Search, ArrowDown} from '../../../assets/icons/component';
import {SolicTable} from './SolicTable.js';
import {useNavigate} from 'react-router-dom';
import {AppRoutes} from "../../../Router";
import {WLOCreditAPIService} from '../../../services';
import {WloCreditoService} from '../../../types';

const Options = [
    {option: 'Cliente'},
    {option: 'Ciudad'},
    {option: 'Estado Firma'},
    {option: 'Estado Credito'},
    {option: 'Linea de Credito'}
]

const solicCopy = {
    back: "Atr\u00e1s",
    title: "Solicitudes de cr\u00e9dito",
};

const searchPlaceholders: Record<string, string> = {
    Cliente: "Buscar cliente",
    Ciudad: "Buscar ciudad",
    "Estado Firma": "Buscar estado de firma",
    "Estado Credito": "Buscar estado de cr\u00e9dito",
    "Linea de Credito": "Buscar l\u00ednea de cr\u00e9dito",
};

const searchFields: Record<string, string> = {
    Cliente: "Pws_Nombres",
    Ciudad: "Pws_ciudad",
    "Estado Firma": "Pws_Estado_Firma",
    "Estado Credito": "Pws_Estado_credito",
    "Linea de Credito": "Pws_Lincre",
};

interface OptionProps {
    Options: {
        option: string
    }[];
    bg: string;
    clr: string;
    str: string;
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLSelectElement>;
}

export const Select: React.FC<OptionProps> = ({Options, bg, clr, str, value, onChange}) => {
    return (
        <li className="solic-filter-control">
            <ArrowDown stroke={str}/>
            <select
                name="search"
                id="search"
                style={{background: bg, color: clr}}
                aria-label="Campo de b\u00fasqueda"
                value={value}
                onChange={onChange}
            >
                {
                    Options.map((option, i) => {
                        return (
                            <option key={i} value={option.option}>{option.option}</option>
                        )
                    })
                }
            </select>
        </li>
    )
}

export const Select2: React.FC<OptionProps> = ({Options, bg, clr, str}) => {
    return (
        <>
            <ArrowDown stroke={str}/>
            <select name="search" id="search" style={{background: bg, color: clr}}>
                {
                    Options.map((option, i) => {
                        return (
                            <option key={i} value={option.option}>{option.option}</option>
                        )
                    })
                }
            </select>
        </>
    )
}

export const SolicDocument: React.FC = () => {
    const navigate = useNavigate();
    const [one] = useState(false)
    const [table, setTable] = useState([])
    const [table2, setTable2] = useState([])
    const [selectedFilter, setSelectedFilter] = useState(Options[0].option)
    const [searchQuery, setSearchQuery] = useState("")

    const applySearch = useCallback((enteredText: string) => {
        const field = searchFields[selectedFilter];
        const normalizedText = enteredText.trim().toUpperCase();

        if (table.length === 0) {
            setTable2([]);
            return;
        }

        if (!normalizedText) {
            setTable2(table);
            return;
        }

        const tablaIngr = table.filter((valor: any) => {
            return String(valor[field] ?? "").toUpperCase().includes(normalizedText);
        })
        setTable2(tablaIngr)
    }, [selectedFilter, table])

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        applySearch(searchQuery);
    }

    useEffect(() => {
        functionss()
    }, [one])
    const functionss = () => {
        let valoragregado: WloCreditoService.SolicitudListadoRequest = {
            Pws_num_solicitud: "",
            Pws_fec_solicitud_ini: "",
            Pws_fec_solicitud_fin: "",
            Pws_Tip_estado: "",
            Pws_Tip_Consulta: "1"
        }
        WLOCreditAPIService.consultaSolicitudListadoCygnus(valoragregado).then((consulta) => {
            if (consulta.payload.data.datos_soli) {
                if (consulta.payload.data.datos_soli.datos_Sol.length > 0) {
                    setTable(consulta.payload.data.datos_soli.datos_Sol)
                    setTable2(consulta.payload.data.datos_soli.datos_Sol)
                }
            }
        }, (error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        const searchTimer = window.setTimeout(() => {
            applySearch(searchQuery);
        }, 500);

        return () => window.clearTimeout(searchTimer);
    }, [searchQuery, applySearch])

    return (
        <main className="solicDoc">
            <div className="solic-doc-toolbar">
                <Fab
                    variant="extended"
                    color="neutral"
                    aria-label={solicCopy.back}
                    onClick={() => {
                        navigate(AppRoutes.MENU_USER, {replace: true});
                    }}
                    className="solic-doc-back-button hooverButtonRed"
                >
                    <ArrowBack sx={{mr: 1}} className="hooverButtonRedsvg"/>
                    {solicCopy.back}
                </Fab>
            </div>

            <section className="solicDocument" aria-labelledby="solic-document-title">
                <div className="solic-document-header">
                    <h4 id="solic-document-title">{solicCopy.title}</h4>
                </div>
                <div className="solicTable">
                    <div className="search">
                        <form action="" method="post" onSubmit={handleSubmit}>
                            <Select
                                Options={Options}
                                bg={`#4A4A4A`}
                                clr={`#fff`}
                                str={`#fff`}
                                value={selectedFilter}
                                onChange={(event) => setSelectedFilter(event.target.value)}
                            />
                            <li className="solic-search-control">
                                <button type="submit" aria-label="Buscar">
                                    <Search/>
                                </button>
                                <input
                                    type="text"
                                    name="seacrh"
                                    placeholder={searchPlaceholders[selectedFilter]}
                                    value={searchQuery}
                                    onChange={(event) => setSearchQuery(event.target.value)}
                                />
                            </li>
                        </form>
                    </div>
                    <div className="table">
                        <SolicTable value={{tablasva: table2, functionss}}/>
                    </div>
                </div>
            </section>
        </main>
    )
}
